import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import {styles} from "assets/jss/card-utilizador.jsx";

import CardAvatar from "./Card/CardAvatar";
import avatar_flor from "../assets/img/avatar_flor.svg";
import Email from "@material-ui/icons/Email";
import Card from "./Card/Card";
import CardBody from "./Card/CardBody";
import Button from "./CustomButtons/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchPlus} from "@fortawesome/free-solid-svg-icons";
import EstadoUtilizador from "./EstadoUtilizador";

class CardUtilizador extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {classes, label, utilizador, pode_ver_utilizador, enviar_email = true} = this.props;

    if (this.props.compact) {
      let nome_utilizador = <EstadoUtilizador nome={utilizador.nome_curto || utilizador.nome} estado={utilizador.estado}/>

      if (pode_ver_utilizador) {
        nome_utilizador = <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
          window.App.hist.push("/perfil/" + utilizador.id);
          window.location.reload(true);
        }}>
          {nome_utilizador} <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/>
        </a>;
      }

      let body = <CardBody style={{display: "flex", flexDirection: "row", justifyContent: "stretch", alignItems: "center"}}>
        <img src={avatar_flor} alt="..." style={{width: 45, borderRadius: 4}}/>
        <div style={{flex: 1, padding: "0 10px"}}>
          {nome_utilizador}
          <h6 style={{textAlign: "left", margin: 0}}>{label}</h6>
        </div>
        {enviar_email && <Button color="info" style={{color: "rgba(53, 170, 80, 0.45)"}} round justIcon simple onClick={() => {
          window.App.hideModal();
          window.App.hist.push("/mensagens", {destinatario: utilizador});
        }}>
          <Email/>
        </Button>}
      </CardBody>

      if (this.props.inline)
        return <div style={{display: "flex", flexDirection: "row", justifyContent: "stretch", alignItems: "center"}}>
          {body}
        </div>

      return <Card>
        {body}
      </Card>;
    }
    return <Card profile>
      <CardAvatar profile>
        <a onClick={e => e.preventDefault()}>
          <img src={avatar_flor} alt="..."/>
        </a>
      </CardAvatar>
      <CardBody profile>
        <h4 className={classes.cardTitle}>{utilizador.nome_curto || utilizador.nome}</h4>
        <h6 className={classes.cardCategory}>{label}</h6>
        <p className={classes.description} style={{textAlign: "left", marginTop: 5}}>
          <strong>NIN:</strong> {utilizador.NIN}<br/>
          <strong>Região:</strong> {utilizador.regiao}<br/>
          <strong>Agrupamento:</strong> {utilizador.agrupamento}<br/>
          <strong>Núcleo:</strong> {utilizador.nucleo}<br/>
        </p>
        <Button color="primary" round onClick={() => {
          window.App.hist.push("/mensagens", {destinatario: utilizador});
        }}>
          <Email/> Enviar mensagem
        </Button>
      </CardBody>
    </Card>;
  }
}

export default withStyles(styles)(CardUtilizador);
